import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/sports';

export default function Categories() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            赛事分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">覆盖全球主流体育项目，满足不同体育爱好者的需求</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {sportCategories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group flex flex-col items-center gap-3 p-5 bg-background-50 border border-background-200 rounded-lg hover:border-primary-300 transition-all cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${category.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-heading font-semibold text-foreground-800 group-hover:text-primary-500 transition-colors">
                {category.name}
              </span>
              <span className="text-xs text-foreground-400 text-center line-clamp-2">
                {category.description}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}